import { combineReducers } from 'redux';

import navBar from '../blocks/navbar/store/reducer';

export default combineReducers({ navBar });
